<template>
	<div class="toper">
		<div class="left" @click="handleLogoClick">合肥科飞视觉数据监管平台</div>
		<div class="right">
			<div class="admin"><i class="el-icon-user-solid" style="margin-right: 5px;"></i>{{ authInfo.uname }}</div>
			<el-button size="mini" type="danger" style="position: relative;margin-left: 15px;"
				@click="exitSystem">退出系统</el-button>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from "vuex"

	export default {
		computed: {
			...mapState([
				'authInfo'
			])
		},
		methods: {
			handleLogoClick() {
				var _path = '/index/data_governance/finance_hospital',
					_currentPath = this.$route.path;
				_currentPath != _path && this.$router.push({
					path: _path
				});
			},
			exitSystem() {
				const that = this;
				// this.$router.replace({
				// 	path: "/index"
				// });
				this.$confirm(
					'此操作将退出该系统，是否继续?',
					'提示', {
						type: 'warning'
					}
				).then(
					() => {
						// window.close();
						that.$router.replace({
							path: "/index"
						});
					}
				).catch(
					() => {}
				);
			}
		}
	}
</script>

<style>
	.data_governance_page .toper {
		display: block;
		position: absolute;
		z-index: 99;
		width: 100%;
		height: 60px;
		top: 0;
		left: 0;
		padding: 0 30px;
		border-bottom: 1px solid #e4e4e3;
		box-shadow: 0 1px 1px #edeced;
		background: #fff;
	}

	.data_governance_page .toper .left {
		float: left;
		font-size: 20px;
		font-weight: bold;
		color: #8a8a8a;
		line-height: 60px;
		cursor: pointer;
	}

	.data_governance_page .toper .right {
		display: block;
		float: right;
		padding: 16px 0 0 0;
		font-size: 0;
	}

	.data_governance_page .toper .right .admin {
		display: inline-block;
		position: relative;
		font-size: 16px;
		line-height: 28px;
		vertical-align: top;
	}
</style>